(function(){
  'use strict';
  /* V38: occasion navigation is owned by sections/arshe-personality-filter.liquid.
     This compatibility file intentionally does not add a second click handler. */
})();
